import { routerStore } from "csi/state/rootStore";
import New from "csi/table/New";
import NewSnapshotTemplateDialog from "csi/threeD/snapshotTemplates/dialogs/NewSnapshotTemplateDialog";
import declare from "dojo/_base/declare";
import { SnapshotTemplateId } from "csi/threeD/snapshotTemplates/snapshotUtils";
import SnapshotTemplateDialogStore from "csi/threeD/snapshotTemplates/dialogs/SnapshotTemplateDialogStore";
import { cnl } from "csi/typings";
import { finalizeReactNewRequest } from "csi/middleware/common";
import { NewInterface } from "csi/table/NewInterface";

const NewSnapshotTemplate = declare(New, {
	/**
	 * @override
	 * Open React dialog
	 */
	preProcess(): void {
		const onSave = async (jsonResponse, newURL: cnl): Promise<void> => {
			this.processReact(jsonResponse);
			finalizeReactNewRequest(this as unknown as NewInterface, newURL);
		};

		const onCancel = (): void => {
			this.onCancelReactDialog();
		};
		const type = this.m_typeNode as SnapshotTemplateId;

		const store = new SnapshotTemplateDialogStore(onCancel, onSave, this.m_writer, type as SnapshotTemplateId);

		this.useReactDialog(routerStore.openDialog(NewSnapshotTemplateDialog, {
			store,
		}));
	},
});

export = NewSnapshotTemplate;